var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "12px",
    viewBox: "0 3 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99904045,8.96269919 C6.99099519,8.71742328 6.89045107,8.48388526 6.71590167,8.30657713 L1.77384288,3.30747571 C1.3796931,2.90910732 0.72736193,2.89582971 0.316326782,3.27935677 C-0.0939052812,3.66210797 -0.106775226,4.29635396 0.287370436,4.69472236 L4.5408357,9.00014846 L0.287370436,13.3055746 C-0.106779344,13.703943 -0.0939093996,14.3374291 0.316326782,14.7209401 C0.72736193,15.1036913 1.37971369,15.0911936 1.77384288,14.6928212 L6.71590167,9.69371979 C6.90895084,9.49687917 7.01110731,9.23364249 6.99904045,8.9626112 L6.99904045,8.96269919 Z",
    fill: "#746250",
    transform: "translate(7,0) scale(-1, 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.d2c324e2c75d78cae9e4e2a44ce04bd8.svg";
export { ForwardRef as ReactComponent };